import SvgIcon from 'components/SvgIcon';
import { useEffect, useCallback, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import './style.scss';

type Props = {
  children: JSX.Element;
  routes: string[];
  name: string;
  svgIcon: string;
  autoOpenClose?: boolean | undefined;
  onOpenChange?: (isOpen: boolean) => void;
  className?: string;
};

const NavCollapse = ({ children, routes, name, svgIcon, autoOpenClose, onOpenChange, className = '' }: Props) => {
  const { pathname } = useLocation();

  const isActive = useCallback((route: string) => {
    if (route.includes(":") && new RegExp("^" + route.replace(/:programId/g, "[a-fA-F0-9]{24}").replace(/:\w+/g, "[^/]+") + "(/|$)").test(pathname)) return true;
    const endSlashPosition = route !== "/" && route.endsWith("/") ? route.length - 1 : route.length;
    return pathname === route || (pathname.startsWith(route) && pathname.charAt(endSlashPosition) === "/");
  }, [pathname]);

  const isInPath = useMemo(() => {
    return routes.some(route => isActive(route));
  }, [routes, isActive]);

  const [isOpen, setIsOpen] = useState(autoOpenClose === true ? autoOpenClose : isInPath);
  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    onOpenChange && onOpenChange(isOpen);
  }, [isOpen, onOpenChange]);

  return (
    <li className={`nav-collapse ${className}`.trim()}>
      <button className={`reset-button-style toggle-btn ${isOpen ? 'is-open' : ''} ${isInPath ? 'active' : ''}`} onClick={() => toggle()}>
        <span className="menu-link-title"><SvgIcon name={svgIcon} />{name}</span>
        <SvgIcon className="chevron" name="chevron" />
      </button>
      <Collapse isOpen={isOpen}>
        <div className="collapse-wrap">{children}</div>
      </Collapse>
    </li>
  );
};

export default NavCollapse;
